<style lang="scss" src="./InputText.scss" scoped></style>

<template>
  <div class='input-text'>
    <label class="label">
      {{ label }} 
      <span v-if="isRequired">*</span>
    </label>

    <input
      v-if='mask'
      class="input"
      :type="inputType"
      :class="{'input-error': inputError}"
      :placeholder='placeholder'
      :disabled='isDisabled'
      @blur='blur'
      @focus='focus'
      v-mask='mask'
      v-model='input'
    />

    <input
      v-else
      class="input"
      :type="inputType"
      :class="{'input-error': inputError}"
      :placeholder='placeholder'
      :disabled='isDisabled'
      @blur='blur'
      @focus='focus'
      v-model='input'
    />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'ProviderInputText',
  props: {
    value: [String, Number],
    label: String,
    placeholder: {
      type: String,
      default: 'Digite aqui...'
    },
    mask: undefined,
    isDisabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    validate: null,
    inputType: { 
      type: String, 
      default: 'text',
      validator: value => ['text', 'number'].includes(value) // Apenas permite 'text' ou 'number'
    }
  },

  directives: { mask },

  data () {
    return {
      input: '',
      inputError: false
    }
  },

  watch: {
    input (eventValue) {
      this.$emit('input', eventValue)
    },
    value () {
      this.input = this.value
    }
  },

  mounted () {
    this.input = this.value ? this.value : ''
  },

  methods: {
    blur (e) {
      this.checkValidate()
      this.$emit('blur', e)
    },
    focus (e) {
      this.$emit('focus', e) // Corrigido para emitir 'focus'
    },

    checkValidate () {
      this.inputError = false
      if (typeof this.validate === 'function') {
        let valid = this.validate(this.input)
        if (valid !== true) {
          this.inputError = true
        }
      }
    }
  }
}
</script>
